import { render, staticRenderFns } from "./AddEditDeleteButton.vue?vue&type=template&id=23651493&scoped=true&"
import script from "./AddEditDeleteButton.vue?vue&type=script&lang=js&"
export * from "./AddEditDeleteButton.vue?vue&type=script&lang=js&"
import style0 from "./AddEditDeleteButton.vue?vue&type=style&index=0&id=23651493&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23651493",
  null
  
)

export default component.exports